//
export const allSelector = (state) => state?.incomeReducer?.all;
export const incomeSelector = (state) => state?.incomeReducer?.income;
